import { render, staticRenderFns } from "./skuEditMultiLang.vue?vue&type=template&id=d872d7b6&"
import script from "./skuEditMultiLang.vue?vue&type=script&lang=ts&"
export * from "./skuEditMultiLang.vue?vue&type=script&lang=ts&"
import style0 from "./skuEditMultiLang.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports